module.exports = __webpack_public_path__ + "img/closing.7f670d5f.png";